import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, ArrowRight, MapPin, CalendarDays } from "lucide-react";
import { api } from "../../lib/api";
import { PageHead, StatusBadge, Stat } from "../../components/Bits";

export default function InspectorHome() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/inspections").then(({ data }) => setList(data)); }, []);
  const by = (s) => (list || []).filter((i) => i.status === s).length;
  return (
    <div className="mx-auto max-w-5xl">
      <PageHead over="Inspector dashboard" title="Assigned inspections">
        <Link to="/inspector/new" className="tap flex h-12 items-center gap-2 rounded-md bg-slate-900 px-5 font-semibold text-white hover:bg-teal-700" data-testid="new-property-button"><Plus className="h-4 w-4" /> New property</Link>
      </PageHead>
      <div className="mb-6 grid grid-cols-3 gap-3">
        <Stat label="Scheduled" value={by("scheduled")} testid="inspector-stat-scheduled" />
        <Stat label="In progress" value={by("in_progress")} accent="text-amber-600" testid="inspector-stat-progress" />
        <Stat label="Completed" value={by("completed")} accent="text-emerald-600" testid="inspector-stat-completed" />
      </div>
      <div className="space-y-2">
        {(list || []).map((i) => {
          const done = i.status === "completed";
          const to = done ? `/inspector/inspection/${i.inspection_id}/summary` : `/inspector/inspection/${i.inspection_id}`;
          return (
            <Link key={i.inspection_id} to={to} className="tap flex flex-col gap-3 rounded-lg border border-slate-200 bg-white p-4 hover:border-slate-900 sm:flex-row sm:items-center" data-testid={`inspection-row-${i.inspection_id}`}>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2"><span className="font-mono text-xs font-bold">{i.inspection_id}</span><StatusBadge status={i.status} />{i.type === "reinspection" && <span className="rounded bg-violet-100 px-1.5 py-0.5 font-mono text-[10px] font-bold text-violet-700">RE-INSPECTION</span>}</div>
                <div className="mt-1 font-semibold">{i.property.project} · {i.property.flat} · {i.property.bhk} BHK</div>
                <div className="mt-1 flex flex-wrap gap-4 text-xs text-slate-500"><span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{i.property.location}</span><span className="flex items-center gap-1"><CalendarDays className="h-3 w-3" />{i.inspection_date}</span><span>{i.customer.name}</span></div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-32"><div className="h-1.5 rounded bg-slate-100"><div className="h-full rounded bg-teal-500" style={{ width: `${i.summary?.progress || 0}%` }} /></div><div className="mt-1 font-mono text-[10px] text-slate-500">{i.summary?.progress || 0}% · {i.summary?.total_observations || 0} obs</div></div>
                <span className="flex h-11 items-center gap-1.5 rounded-md bg-slate-900 px-4 text-sm font-bold text-white">{done ? "Report" : i.status === "scheduled" ? "Start" : "Continue"}<ArrowRight className="h-4 w-4" /></span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
